/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Toolkit_TypeInputs */

const en_pc_alt_t_toolkit_type = /** @type {(inputs: Pc_Alt_T_Toolkit_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser-based collection of PDF tools, unrelated to PdfCraft`)
};

const zh_pc_alt_t_toolkit_type = /** @type {(inputs: Pc_Alt_T_Toolkit_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器端 PDF 工具集，与 PdfCraft 无关`)
};

/**
* | output |
* | --- |
* | "Browser-based collection of PDF tools, unrelated to PdfCraft" |
*
* @param {Pc_Alt_T_Toolkit_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_toolkit_type = /** @type {((inputs?: Pc_Alt_T_Toolkit_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Toolkit_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_toolkit_type(inputs)
	return zh_pc_alt_t_toolkit_type(inputs)
});
export { pc_alt_t_toolkit_type as "pc.alt.t.toolkit.type" }